
export const LIVE_DATE = 1552611600000;
export const TICKET_SALE_DATE = 1552654800000;
export const shouldFilter = () => {
    // return true;
    let list = ['localhost', 'ted.staging.3njoy.net', '10.1.10.', '192.168.1.'];
    for (let i = 0; i < list.length; i++) {
        const environment = list[i];
        if (window.location.host.indexOf(environment) >= 0) {
            return false;
        }
    }
    return true;
}